import { render } from "./recovery_form.vue?vue&type=template&id=8c6bdcbc"
import script from "./recovery_form.js?vue&type=script&lang=js"
export * from "./recovery_form.js?vue&type=script&lang=js"

import exportComponent from "/home/jojo/Documents/aspho-fe-pleromer/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__